import type { PblAuthUser, PblCase } from '@/types/pbl';

import { findCurrentPendingLawyerAssignment } from './lawyerCaseState';

const hiddenLawyerCurrentCaseStatuses = new Set<PblCase['status']>(['manual_assignment_required']);

const pendingLawyerConfirmationStatuses = new Set<PblCase['status']>(['lawyer_invited', 'pending_lawyer_response']);

export const isPendingLawyerConfirmationCase = (
  item: Pick<PblCase, 'status' | 'assignments'>,
  userData?: Pick<PblAuthUser, 'pbl_lawyer_profile'> | null
) => {
  if (!pendingLawyerConfirmationStatuses.has(item.status)) return false;

  if (!item.assignments?.length) return true;

  return Boolean(findCurrentPendingLawyerAssignment(item, userData));
};

export const isLawyerCurrentCase = (item: Pick<PblCase, 'status'>) =>
  !pendingLawyerConfirmationStatuses.has(item.status) && !hiddenLawyerCurrentCaseStatuses.has(item.status);
